import { useSession } from 'next-auth/react';
import { useIsArchonApp } from '@resources/js/contexts/useIsArchonApp';

export default function useLoadAdScripts(): boolean {
  const isArchonApp = useIsArchonApp();
  const { data: session, status: sessionStatus } = useSession();

  return (
    !isArchonApp &&
    sessionStatus !== 'loading' &&
    !session?.user.enabledFeatures.noAds
  );
}
